export default __webpack_public_path__ + "static/media/kinvey.00b37ef4.svg";